import api from "./api";
import consts, { mapKeys } from "./consts";
import languages from "./languages/languages.json";
import { get, post, put, del } from "./api/request";

const locale = "pt-br"

const lang = languages[locale]

let branch_owner = window.localStorage.getItem(consts.CURRENT_BRANCH)
let allBranches = window.localStorage.getItem(consts.ALL_BRANCHES)
let user = window.localStorage.getItem(consts.USER_DATA)
let plans = window.localStorage.getItem(consts.PLANS)
let certificates = window.localStorage.getItem(consts.CERTIFICATES)

function getBranchOwner() {
  const current = window.localStorage.getItem(consts.CURRENT_BRANCH);
  if (current && current !== "undefined") {
    try {
      return JSON.parse(current);
    } catch (e) {
      return null;
    }
  }
  return null;
}

function getAllBranches() {
  const current = window.localStorage.getItem(consts.ALL_BRANCHES);
  if (current && current !== "undefined") {
    try {
      return JSON.parse(current);
    } catch (e) {
      return [];
    }
  }
  return [];
}

function getUser() {
  const current = window.localStorage.getItem(consts.USER_DATA);
  if (current && current !== "undefined") {
    try {
      return JSON.parse(current);
    } catch (e) {
      return null;
    }
  }
  return null;
}

function getPlan() {
  const current = window.localStorage.getItem(consts.PLANS);
  if (current && current !== "undefined") {
    try {
      const parsed = JSON.parse(current);
      return Array.isArray(parsed) ? parsed[0] : parsed;
    } catch (e) {
      return null;
    }
  }
  return null;
}

function getCertificates() {
  const current = window.localStorage.getItem(consts.CERTIFICATES);
  if (current && current !== "undefined") {
    try {
      let json = JSON.parse(current);
      return Array.isArray(json) ? json.reverse() : [];
    } catch (e) {
      return [];
    }
  }
  return [];
}

export function getFormatedDate(date) {
  if (date) {
    date = new Date(date)
  } else {
    date = new Date()
  }

  const dateObject = {
    LongMonth: new Date(date).toLocaleString(locale, {
      "month": "long"
    }),
    LongWeekday: new Date(date).toLocaleString(locale, {
      "weekday": "long"
    })
  }
  return dateObject
}

const config = {
  api,
  consts,
  mapKeys, 
  get,
  post,
  put,
  del,
  getBranchOwner,
  getAllBranches,
  getUser,
  getPlan,
  getCertificates,
};

export { 
  api, 
  consts,
  get, 
  post, 
  put, 
  del, 
  getBranchOwner, 
  getUser, 
  getPlan, 
  getCertificates, 
  getAllBranches,
  mapKeys 
};
export default config;



// WEBPACK FOOTER //
// ./src/sources/config.jsx